export let Code = {
type: `@Component({
    selector: 'app-table',
    template:
        <h3 class="first">基础列表</h3>
        <div>
            <app-table [tableData]='proTableData' (fromChild)="getOptInfo($event)"></app-table>
        </div>

        <h3 class="first">分页</h3>
        <div>
            <app-table [tableData]='proTableData' (fromChild)="getOptInfo($event)"></app-table>
        </div>

        <h3 class="first">操作</h3>
        <div>
            <app-table [tableData]='proTableCom' (fromChild)="getOptInfo($event)"></app-table>
            <app-page [pageData]='appPage' (fromChild)="updatePageList($event)"></app-page>
        </div>
})
export class Table {
    code = Code;
    constructor() { }

    ngOnInit() {

    }

    curObj;
    num;

    proTableData = {
        operate: false,
        th: [
          {
            'title': '名称'
          },
          {
            'title': '别名'
          },
          {
            'title': '创建人'
          },
          {
            'title': '更新时间'
          }
        ],
        td: [
          {
            a: {
              title: "name",
              url: "appUrl",
              params: "appParams"
            }
          },
          {
            key: "display_name"
          },
          {
            key: "created_by"
          },
          {
            key: "update_at"
          }
        ],
        list: [{
          appUrl: "/project/detail",
          appParams: { id: '11111111' },
          name: "digitalOne",
          created_by: "张三",
          display_name: "digitalone",
          update_at: "2018-04-03 15:35:30",
          showOperateList: [
            {
              a: {
                'name': '删除',
                'fn': 'delShow'
              }
            }]
        }],
    };
    
    getOptInfo(e) {
        this.curObj = e.optInfo.targetObj;
        if (e.optInfo) {
          this[e.optInfo.optName]();
        }
    }
}
`,
page: `@Component({
    selector: '[app-table,app-page]',
    template:
        <h3 class="first">分页</h3>
        <div>
            <app-table [tableData]='proTableData' (fromChild)="getOptInfo($event)"></app-table>
            <app-page [pageData]='appPage' (fromChild)="updatePageList($event)"></app-page>
        </div>
})
export class Table {
    code = Code;
    constructor() { }

    ngOnInit() { }

    curObj;
    num;
    appPage = {
        size: 10,
        total: 100
    };

    proTableData = {
        operate: false,
        th: [
          {
            'title': '名称'
          },
          {
            'title': '别名'
          },
          {
            'title': '创建人'
          },
          {
            'title': '更新时间'
          }
        ],
        td: [
          {
            a: {
              title: "name",
              url: "appUrl",
              params: "appParams"
            }
          },
          {
            key: "display_name"
          },
          {
            key: "created_by"
          },
          {
            key: "update_at"
          }
        ],
        list: [{
          appUrl: "/project/detail",
          appParams: { id: '11111111' },
          name: "digitalOne",
          created_by: "张三",
          display_name: "digitalone",
          update_at: "2018-04-03 15:35:30",
          showOperateList: [
            {
              a: {
                'name': '删除',
                'fn': 'delShow'
              }
            }]
        }],
    };
  

    updatePageList(obj) {
        this.num = obj.num;
    }

    getOptInfo(e) {
        this.curObj = e.optInfo.targetObj;
        if (e.optInfo) {
          this[e.optInfo.optName]();
        }
    }
}
`,
operate: `@Component({
    selector: '[app-table,app-page]',
    template:
        <h3 class="first">操作</h3>
        <div>
            <app-table [tableData]='proTableCom' (fromChild)="getOptInfo($event)"></app-table>
            <app-page [pageData]='appPage' (fromChild)="updatePageList($event)"></app-page>
        </div>
})
export class Table {
    code = Code;
    constructor() { }

    ngOnInit() {

    }

    curObj;
    num;
    appPage = {
        size: 10,
        total: 100
    };

    proTableCom = {
        operate: true,
        th: [
          {
            'title': '名称'
          },
          {
            'title': '别名'
          },
          {
            'title': '创建人'
          },
          {
            'title': '更新时间'
          }
        ],
        td: [
          {
            a: {
              title: "name",
              url: "appUrl",
              params: "appParams"
            }
          },
          {
            key: "display_name"
          },
          {
            key: "created_by"
          },
          {
            key: "update_at"
          }
        ],
        list: [{
          appUrl: "/project/detail",
          appParams: { id: '11111111' },
          name: "digitalOne",
          created_by: "张三",
          display_name: "digitalone",
          update_at: "2018-04-03 15:35:30",
          showOperateList: [
            {
              a: {
                'name': '删除',
                'fn': 'delShow'
              }
            }]
        }],
    };

    updatePageList(obj) {
        this.num = obj.num;
    }

    getOptInfo(e) {
        this.curObj = e.optInfo.targetObj;
        if (e.optInfo) {
          this[e.optInfo.optName]();
        }
    }
}
`,

};


// WEBPACK FOOTER //
// ./src/app/code/table.ts